import { createSelector } from 'reselect';
export const LAYOUT = window.innerHeight > window.innerWidth ? 'portrait' : 'landscape';

const getBrand = state => state.business.brand;

export const getAssets = createSelector(
    [getBrand],
    (brand) => {
        if (brand && brand.assets) {
            const { assets } = brand;

            const logo = (assets.logo.assets[0] || {}).url;
            const dishPlaceholder = (assets.dishPlaceholder.assets[0] || {}).url;
            const mainBackground = assets.mainBackground.assets.length <= 1
                ? (assets.mainBackground.assets[0] || {}).url
                : assets.mainBackground.assets.find(asset => asset.url.includes(LAYOUT)).url;

            return { logo, dishPlaceholder, mainBackground };
        }

        return {};
    }
);
